import Typography from "@mui/material/Typography";

const NotFound = () => {
    return (
        <>
            <Typography variant="h2">Page Not Found!</Typography>
            <Typography sx={{ my: 2}}>Sorry, the page you are looking for could not be found.</Typography>
        </>
    );
};

export default NotFound;